import { render, staticRenderFns } from "./LeaveReview.vue?vue&type=template&id=06f77850&lang=pug&"
import script from "./LeaveReview.vue?vue&type=script&lang=js&"
export * from "./LeaveReview.vue?vue&type=script&lang=js&"
import style0 from "./LeaveReview.vue?vue&type=style&index=0&id=06f77850&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports